/**
 * 화면 빌드 버전 비교 — "지금 브라우저에 떠 있는 화면"과 "서버가 지금 내주는 화면"이 다른가.
 *
 * 왜 있나: 화면과 서버는 같은 이미지로 함께 나가지만, 배포 **전**부터 열려 있던 탭은 옛
 * 자바스크립트를 계속 쓴다. 그 탭이 새 서버의 달라진 응답을 받으면 화면 한가운데서 터진다
 * (2026-09-03 요금제 구간표 업로드 — 서버는 새 "탭을 고르세요" 응답을, 화면은 옛 코드로 받아
 * `undefined.length` 크래시). 배포 뒤 옛 탭이 스스로 알아채게 하는 게 유일한 방어라 이 비교가 있다.
 *
 * 값의 출처: 이미지를 굽는 자리(Dockerfile.web)가 같은 APP_VERSION 을 두 곳에 박는다 —
 *   ① 번들 안 `VITE_APP_VERSION`(= 브라우저가 들고 있는 값)
 *   ② nginx 가 no-store 로 내주는 `/version.txt`(= 지금 서버에 있는 값)
 * 둘이 다르면 새 빌드가 나간 것이다.
 */

/** 로컬 개발·검증처럼 버전이 안 박힌 빌드를 뜻하는 값. 이때는 절대 "새 빌드"로 판정하지 않는다. */
export const UNVERSIONED_BUILD = "dev";

function normalize(value: string | null | undefined): string {
  return (value ?? "").trim();
}

/**
 * 새 빌드가 나갔는가.
 * - 둘 중 하나라도 비었거나 `dev` 면 false — 판단 재료가 없을 땐 새로고침을 시키지 않는다
 *   (로컬 개발 서버·검증 빌드에서 무한 새로고침 사고를 막는 안전핀).
 * - 그 외엔 문자열이 다르면 true.
 */
export function isNewBuildAvailable(
  current: string | null | undefined,
  served: string | null | undefined,
): boolean {
  const mine = normalize(current);
  const theirs = normalize(served);
  if (!mine || !theirs) return false;
  if (mine === UNVERSIONED_BUILD || theirs === UNVERSIONED_BUILD) return false;
  return mine !== theirs;
}
